import { createI18n } from 'vue-i18n'
import ja from '../locales/ja.js'
import en from '../locales/en.js'
import vi from '../locales/vi.js'
import th from '../locales/th.js'

const messages = {
  ja,
  en,
  vi,
  th
}

// Get default locale (Get from localStorage or browser settings)
function getDefaultLocale() {
  const saved = localStorage.getItem('locale')
  if (saved && messages[saved]) {
    return saved
  }
  
  const browserLang = navigator.language.split('-')[0]
  if (messages[browserLang]) {
    return browserLang
  }
  
  return 'ja' // Default to Japanese if no match found
}

const i18n = createI18n({
  legacy: false,
  locale: getDefaultLocale(),
  fallbackLocale: 'ja',
  messages
})

export default i18n

// Export functions to change and get locale
export function setLocale(locale) {
  if (messages[locale]) {
    i18n.global.locale.value = locale
    localStorage.setItem('locale', locale)
    document.documentElement.lang = locale
  }
}

export function getLocale() {
  return i18n.global.locale.value
}

export function getAvailableLocales() {
  return Object.keys(messages)
}